export const INSIDE_FIFA_TEAM_ADMIN = 'FMC_Inside_FIFA_Admin';
export const INSIDE_FIFA_TEAM_READ_ONLY = 'FMC_Inside_FIFA_Read_Only';
export const ALL_INSIDE_FIFA_TEAM_GROUPS = [INSIDE_FIFA_TEAM_ADMIN, INSIDE_FIFA_TEAM_READ_ONLY];
